<div class="row">
    <div class="btn-guardar" style="margin-left: 25px;color: #F5BB3F;background: #FFF;text-align: center;width: 500px;">
        <p class="statusname" *ngIf="pme?.estado === 0">estado: Fase Estratégica No iniciada</p>
        <p class="statusname" *ngIf="pme?.estado === 1">estado: Fase Estratégica Iniciada</p>
        <p class="statusname" *ngIf="pme?.estado === 2">estado: Fase Estratégica Finalizada</p>
        <p class="statusname" *ngIf="pme?.estado === 3">estado: Fase Anual 2024 Iniciada</p>
        <p class="statusname" *ngIf="pme?.estado === 4">estado: Fase Anual 2024 Finalizada</p>
        <p class="statusname" *ngIf="pme?.estado === 5">estado: Fase Anual 2025 Iniciada</p>
        <p class="statusname" *ngIf="pme?.estado === 6">estado: Fase Anual 2025 Finalizada</p>
        <p class="statusname" *ngIf="pme?.estado === 7">estado: Fase Anual 2026 Iniciada</p>
        <p class="statusname" *ngIf="pme?.estado === 8">estado: Fase Anual 2026 Finalizada</p>
        <p class="statusname" *ngIf="pme?.estado === 9">estado: Fase Anual 2027 Iniciada</p>
        <p class="statusname" *ngIf="pme?.estado === 10">estado: Fase Anual 2027 Finalizada</p>
    </div>
</div>

<div class="customers" *ngIf="componente===''">
    <div class="card">
        <div class="card-body" style="padding: 20px;">
            <div class="row" style="padding: 1rem;">
                <div class="col-sm-6" style="padding: 1rem;">
                    <p style="text-align: left;
                        font: normal normal bold 26px/53px Montserrat;
                        letter-spacing: 0px;
                        color: #00B09E;
                        opacity: 1;">Plan de Mejoramiento Educativo</p>
                    <p style="text-align: left;
                        letter-spacing: 0px;
                        color: #30374B;
                        opacity: 1;"><b></b></p>
                    <p style="text-align: left;
                        letter-spacing: 0px;
                        color: #30374B;
                        opacity: 1;">En esta sección podrá registrar el Plan de Mejoramiento Educativo, instancia de planificación que permite a la comunidad educativa organizar de manera sistémica e integrada los objetivos, metas, estrategias y acciones que permitan
                        consolidar los procesos de mejoramiento avanzando en el desarrollo de la calidad de la práctica educativas que favorezcan los aprendizajes y el desarrollo pleno e integral de todos los niños y niñas.</p><br>
                    <div class="col-sm-12">
                        <div class="card-header">
                            <div class="row">
                                <p class="data-card-info">Identificación de la Institución</p>
                                <table class="table-info">
                                    <tr>
                                        <td>
                                            <p class="table-row-title">Nombre:</p>
                                        </td>
                                        <td>Junta Nacional de Jardines Infantiles

                                        </td>
                                    </tr>
                                    <tr class="table-tr-shadow">
                                        <td>
                                            <p class="table-row-title">Sitio Web:</p>
                                        </td>
                                        <td>www.junji.gob.cl

                                        </td>
                                    </tr>
                                    <tr class="table-tr-shadow">
                                        <td>
                                            <p class="table-row-title">Dirección:</p>
                                        </td>
                                        <td>Morandé 226, Santiago Centro, región Metropolitana de Santiago.

                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6" style="padding: 1rem;">
                    <div class="card-header" style="height: 100%;">
                        <div class="row">
                            <p class="data-card-info">Identificación de la Unidad Educativa</p>
                            <table class="table-info">
                                <tr>
                                    <td>
                                        <p class="table-row-title">Código:</p>
                                    </td>
                                    <td>{{uniEducativa.rbd}}</td>
                                </tr>
                                <tr class="table-tr-shadow">
                                    <td>
                                        <p class="table-row-title">Nombre:</p>
                                    </td>
                                    <td>{{uniEducativa.nombreJardin}}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="table-row-title">Programa:</p>
                                    </td>
                                    <td>{{uniEducativa.programa}}</td>
                                </tr>
                                <tr class="table-tr-shadow">
                                    <td>
                                        <p class="table-row-title">Modalidad:</p>
                                    </td>
                                    <td>{{uniEducativa.modalidad}}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="table-row-title">Teléfono:</p>
                                    </td>
                                    <td>{{uniEducativa.telefono}}</td>
                                </tr>
                                <tr class="table-tr-shadow">
                                    <td>
                                        <p class="table-row-title">Dirección:</p>
                                    </td>
                                    <td>{{uniEducativa.direccion}}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="table-row-title">Comuna:</p>
                                    </td>
                                    <td>{{uniEducativa.comuna}}</td>
                                </tr>
                                <tr class="table-tr-shadow">
                                    <td>
                                        <p class="table-row-title">Región:</p>
                                    </td>
                                    <td>{{uniEducativa.region}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>
    <div class="row">
        <div class="col-4">
            <div class="card" style="margin: 9px;">
                <div class="card-body" style="padding: 20px;">
                    <div class="fase-estrategica">
                        <div class="d-flex flex-row-reverse">
                            <div class="check-fase" [ngClass]="pme?.estado >= 2 ? 'check-fase check-fase-completado' : 'check-fase'"><i class="fas fa-check"></i></div>
                        </div>
                        <div class="row justify-content-center">
                            <p class="data-card-title">Fase Estratégica PME</p>
                            <button type="button" (click)="irA('fase-estrategica')" class="btn btn-light btn-ver" *ngIf="pme?.estado >= 1">VER</button>
                            <button type="button" (click)="irA('fase-estrategica')" class="btn btn-light btn-send" *ngIf="pme?.estado === 0" >INICIAR</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-4">
            <div class="card" style="margin: 9px;">
                <div class="card-body" style="padding: 20px;">
                    <div class="fase-anual">
                        <div class="d-flex flex-row-reverse">
                            <div class="check-fase" [ngClass]="pme?.estado >= 5 ? 'check-fase check-fase-completado' : 'check-fase'"><i class="fas fa-check"></i></div>
                        </div>
                        <div class="row justify-content-center">
                            <p class="data-card-title">Fase Anual PME</p>                            
                            <button type="button" (click)="irA('fase-anual')" class="btn btn-light btn-ver" *ngIf="pme?.estado >= 3" >VER</button>
                            <button type="button" class="btn btn-light btn-send" disabled *ngIf="pme?.estado < 2">INICIAR</button>
                            <button type="button" (click)="irA('fase-anual')" class="btn btn-light btn-send" *ngIf="pme?.estado === 2">INICIAR</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-4">
            <div class="card" style="margin: 9px;">
                <div class="card-body" style="padding: 20px;">
                    <div class="descargar-pme">
                        <div class="d-flex flex-row-reverse">
                            <div class="check-fase" [ngClass]="pme?.estado >= 5 ? 'check-fase check-fase-completado' : 'check-fase'"><i class="fas fa-check"></i></div>
                        </div>
                        <div class="row justify-content-center">
                            <p class="data-card-title">Descargar PME</p>

                            <button title="EXCEL" class="btn btn-light btn-send" (click)="seleccionarPeriodo()" >
                                <a style="color: #ffffff;" >EXCEL</a>
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
    <br>
</div>


<app-pme-fase-estrategica [simulacion]="simulacion" *ngIf="componente==='fase-estrategica'"></app-pme-fase-estrategica>
<app-pme-fase-anual [simulacion]="simulacion" *ngIf="componente==='fase-anual'"></app-pme-fase-anual>


<ng-template #modalSeleecionInforme let-modal class="modal-dialog modal-xl">
    <div class="modal-header" style="padding: 0px " width="100%">
        <h5 id="modalTitleUser" class="titulo-card-amarillo" style="    margin: 25px">Seleccione periodo</h5>
        <button type="button" class="close" (click)="close()" style="background: none;border: none;font-size: xx-large;">
          <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="padding: 50px;" width="100%">
        <div class="row">
            <div class="col-sm-2">

            </div>
            <div class="col-sm-8">
                <div class="row">
                    <div class="col-sm-6 d-flex align-items-center" style="background-color: #FFF;">
                        <p class="content text-meta-anio data-card-title">FASE ANUAL 2024</p>
                    </div>
                    <div class="col-sm-6" style="background-color: #FFF;">
                        <button title="EXCEL" class="btn btn-light btn-send" *ngIf="pme?.estado >= 4" (click)="downloadExcel('2024')">
                            <a style="color: #ffffff;" target="_blank">EXCEL</a>
                        </button>
                        <button title="EXCEL" class="btn btn-light btn-send" *ngIf="pme?.estado < 4" disabled>
                            <a style="color: #FFF;" >EXCEL</a>
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6 d-flex align-items-center" style="background-color: #FFF;">
                        <p class="content text-meta-anio data-card-title">FASE ANUAL 2025</p>
                    </div>
                    <div class="col-sm-6" style="background-color: #FFF;" >
                        <button title="EXCEL" class="btn btn-light btn-send" *ngIf="pme?.estado >= 6" (click)="downloadExcel('2025')">
                            <a Style="color: #ffffff;" target="_blank">EXCEL</a>
                        </button>
                        <button title="EXCEL" class="btn btn-light btn-send"  *ngIf="pme?.estado < 6" disabled>
                            <a style="color: #FFF;" >EXCEL</a>
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6 d-flex align-items-center" style="background-color: #FFF;">
                        <p class="content text-meta-anio data-card-title">FASE ANUAL 2026</p>
                    </div>
                    <div class="col-sm-6" style="background-color: #FFF;">
                        <button title="EXCEL" class="btn btn-light btn-send" *ngIf="pme?.estado >= 8" (click)="downloadExcel('2026')">
                            <a style="color: #ffffff;" target="_blank">EXCEL</a>
                        </button>
                        <button title="EXCEL" class="btn btn-light btn-send" *ngIf="pme?.estado < 8" disabled>
                            <a style="color: #FFF;" >EXCEL</a>
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6 d-flex align-items-center" style="background-color: #FFF;">
                        <p class="content text-meta-anio data-card-title">FASE ANUAL 2027</p>
                    </div>
                    <div class="col-sm-6" style="background-color: #FFF;">
                        <button title="EXCEL" class="btn btn-light btn-send" *ngIf="pme?.estado >= 10">
                            <a [attr.href]="urlInformeExcelPME4" style="color: #ffffff;" target="_blank">EXCEL</a>
                        </button>
                        <button title="EXCEL" class="btn btn-light btn-send" *ngIf="pme?.estado < 10" disabled>
                            <a style="color: #FFF;" >EXCEL</a>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-sm-2">

            </div>
        </div>
    </div>
</ng-template>


<ng-template #modalInforme let-modal class="modal-dialog modal-xl">
    <div class="modal-header" style="padding: 0px " width="100%">
        <h5 id="modalTitleUser" class="titulo-card-amarillo" style="    margin: 25px">Plan de Mejoramiento Educativo</h5>
        <button type="button" class="close" (click)="close()" style="background: none;border: none;font-size: xx-large;">
          <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="padding: 0px;" width="100%">
        <iframe [src]="urlSafe" frameborder="0" width="100%" style="min-height: 700px;" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen> </iframe>
    </div>
</ng-template>